import { GADimension } from '@ps/web-core-enums';
import {
  setCustomUrl,
  setReferrerUrl,
  trackPageView as trackPageViewBrowser
} from '@snowplow/browser-tracker';
import { trackPageView as trackPageViewWebview } from '@snowplow/webview-tracker';
import ReactGA from 'react-ga';
import URL from 'url-parse';

import type { TrackingContextValue } from '../providers/TrackingContext';

let referrerUrl = '';

export const pageView = (context: TrackingContextValue, pathname: string, title?: string) => {
  title ? ReactGA.pageview(pathname, undefined, title) : ReactGA.pageview(pathname);
  ReactGA.set({ [GADimension.PageOriginPath]: pathname });
  setCustomUrl(pathname);
  referrerUrl && setReferrerUrl(referrerUrl);
  referrerUrl = new URL(pathname, true).toString();
  const trackPageView = context.isMobileEmbedded ? trackPageViewWebview : trackPageViewBrowser;
  title ? trackPageView({ title }) : trackPageView();
};
